import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { PhotographOutline } from '@bonusly/design-system';

import { useFileSelector } from '../../hooks/use-file-selector';
import { useIsEnabled } from '../../hooks/use-is-enabled';
import { DecorationButton } from './decoration-button';

export const ImageButton: FC = () => {
	const isEnabled = useIsEnabled('image');
	const openFileSelector = useFileSelector({
		allowedExtensions: ['jpg', 'jpeg', 'png', 'gif'],
	});
	const { t } = useTranslation('action_input');

	if (!isEnabled) {
		return null;
	}

	return (
		<DecorationButton label={t('decorations.upload_image_tooltip')} onClick={openFileSelector}>
			<PhotographOutline />
		</DecorationButton>
	);
};
